import React from 'react';
import DatePicker from 'react-datepicker';
import { parse } from 'date-fns';
import { Container, Row, Col } from 'react-bootstrap';
import './DisplayCalendar.css';

export default function DisplayCalendar(props) {
    return (
        <Container className="report-calendar-container">       
            <Row className="report-calendar-row">
                <Col className="report-calendar-col">
                    {props.selectedDate && props.minDate && props.maxDate && 
                        <DatePicker className="form-control form-control-sm"
                            tabIndex={0}
                            title="Reports date calendar"
                            inline
                            showPopperArrow={false}
                            strictParsing={true}
                            dateFormat="dd/MM/yyyy"
                            selected={props.selectedDate && parse(props.selectedDate, "dd/MM/yyyy", new Date())}
                            minDate={props.minDate && parse(props.minDate, "dd/MM/yyyy", new Date())}
                            maxDate={props.maxDate && parse(props.maxDate, "dd/MM/yyyy", new Date())}
                        />
                    }
                </Col>
            </Row>
        </Container>
    );
}